<template>
	<div class="reservation-play">
		<br />
		<br />
		<img
			src="../../../static/assets/reservation/play/banner.jpg"
			width="100%"
			style="display: block; max-width: 1000px; margin: auto"
		/>
		<PageTitle
			ch="偶在穀倉玩"
			en="世界戲偶展覽 × 偶戲基地探訪 × 互動偶戲劇場"
		></PageTitle>
		<br />
		<br />
		<BannerSplit2ReservationPlay></BannerSplit2ReservationPlay>
		<br />
		<div style="max-width: 1200px; padding: 5%; margin: auto">
			<!-- <img class="desktop" src="../../../static/assets/reservation/play/chart.jpg" width="100%">
			<img class="mobile" src="../../../static/assets/reservation/play/chart_mobile1.jpg" width="100%" style="max-width:300px; margin:auto;">
			<br>
			<img class="mobile" src="../../../static/assets/reservation/play/chart_mobile2.jpg" width="100%" style="max-width:300px; margin:auto;">
			<br>
			<br> -->

			<!-- <table>
        <tr>
          <th>
            <img src="../../../static/assets/reservation/play/icon1.png" />
          </th>
          <td>預約時段｜每日 上午9:30-12:00、下午13:30-17:00</td>
        </tr>
        <tr>
          <th>
            <img src="../../../static/assets/reservation/play/icon1.png" />
          </th>
          <td>
            預約人數｜10人成團（人數未滿以10人計費） <br />
            <b style="font-weight:bold;">優惠方案</b><br />
            <span style="color:#009741;">- 滿20人 可享1人免費</span><br />
            <span style="color:#009741;">- 滿30人 可享2人免費</span><br />
            <span style="color:#009741;">- 滿40人 可享3人免費（以此類推）</span>
          </td>
        </tr>
        <tr>
          <th>
            <img src="../../../static/assets/reservation/play/icon1.png" />
          </th>
          <td>建議提前兩週預約，以便安排場地與導覽員</td>
        </tr>
        <tr>
          <th>
            <img src="../../../static/assets/reservation/play/icon1.png" />
          </th>
          <td>如有深度偶戲體驗及客製化活動需求，歡迎來電洽詢 (03) 950-1977</td>
        </tr>
      </table> -->
			<!-- <br />
      <br /> -->

			<div class="center">
				<img
					src="@/assets/reservation_form.png"
					style="width: 100%; max-width: 900px"
				/>
			</div>
			<div class="center">
				<a
					href="https://docs.google.com/forms/d/e/1FAIpQLSdx0goDvVPQG9WKKLF9YFYrHbu6SgPINLWzfoMnDC6Zy4M6Ag/viewform"
					target="_blank"
					style="width: 100%; max-width: 900px"
				>
					<img
						src="../../../static/assets/reservation/play/btn.png"
						width="100%"
					/>
				</a>
			</div>
		</div>
		<br />
		<br />
		<br />
		<br />
		<br />
		<br />
		<br />
		<br />
	</div>
</template>

<script>
import BannerSplit2ReservationPlay from "@/components/banner/banner_split2_reservation_play";
import PageTitle from "@/components/page_title";

export default {
	metaInfo: {
		title: "利澤國際偶戲藝術村",
	},
	name: "reservation_play",
	data() {
		return {};
	},
	components: {
		PageTitle,
		BannerSplit2ReservationPlay,
	},
};
</script>

<style lang="scss" scoped>
th img {
	height: 1em;
}
th,
td {
	vertical-align: baseline;
	padding: 0 3px;
	line-height: 1.5;
}
@media screen and (min-width: 769px) {
	.mobile {
		display: none;
	}
}
@media screen and (max-width: 768px) {
	.desktop {
		display: none;
	}
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
@import '../../stylesheet/base.sass'
@import '../../stylesheet/layout.sass'

.reservation-play
iframe
	+size(100%, 1000px)
	.apply
			width: 100%
			margin: 100px 0
			text-align: center
			font-size: 24px
</style>



// WEBPACK FOOTER //
// src/pages/reservation/reservation_play.vue